import React from "react";
import { useTranslation } from "react-i18next";
import { AvailableForecastModel } from "modules/DemandForecast/services/AvailableForecastModel";
import { SBBox, SBTypography, SBIconButton } from "modules/Commons";
import { Radio } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { SBTableColumn } from "modules/Commons/SBDataDisplays/SBTable/models/TableColumn";

export const useHeaders = (onOpenConfig: (model: AvailableForecastModel) => void) => {
	const { t } = useTranslation();
	const headers: SBTableColumn<AvailableForecastModel>[] = React.useMemo(() => [
		{
			id: () => "model",
			name: t("model", "Modelos"),
			headers: [
				{
					id: (e: AvailableForecastModel) => (
						<SBBox width="100%">
							<SBTypography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'normal', display: 'block', maxWidth: 'none' }}>{e.code}</SBTypography>
						</SBBox>
					),
					name: t("code", "Code"),
					align: "left",
					width: 150,
				},
				{
					id: (e: AvailableForecastModel) => (
						<SBBox width="100%">
							<SBTypography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'normal', display: 'block', maxWidth: 'none' }}>{e.description}</SBTypography>
						</SBBox>
					),
					name: t("description", "Description"),
					align: "left",
					width: 500,
				},
				{
					id: (e: AvailableForecastModel) => (
						<SBBox display="flex" justifyContent="flex-start">
							{e.required ? (
								<SBTypography variant="body2" fontWeight={600} color="primary.main">
									{t("forecastRequired", "Forecast (Required)")}
								</SBTypography>
							) : e.isDefaultBenchmark ? (
								<SBTypography variant="body2" fontWeight={600} color="secondary.main">
									{t("benchmark", "Benchmark")}
								</SBTypography>
							) : (
								<SBTypography variant="body2" color="textSecondary">
									-
								</SBTypography>
							)}
						</SBBox>
					),
					name: t("status", "Status"),
					align: "left",
					width: 200,
					fixed: true,
					maxWidth: 200,
				},
				{
					id: (e: AvailableForecastModel) => e.lastTrainingDate ? new Date(e.lastTrainingDate).toLocaleDateString() : "-",
					name: t("lastTraining", "Last Training"),
					align: "left",
					width: 150,
					fixed: true,
					maxWidth: 150,
				},
				{
					id: (e: AvailableForecastModel) => (
						<SBBox display="flex" justifyContent="center">
							<SBIconButton onClick={() => onOpenConfig(e)}>
								<MoreHorizIcon sx={{ color: "primary.main", fontSize: 20 }} />
							</SBIconButton>
						</SBBox>
					),
					name: " ",
					align: "center",
					width: 60,
					fixed: true,
					maxWidth: 60,
				},
			],
		}
	], [t, onOpenConfig]);

	return { headers };
};

// Triggering recompile to clear stale ts cache
